module.exports = __webpack_public_path__ + "static/media/ic-checkmark-white.f98182d9.svg";